import { axiosClient } from '../axiosClient';

// Espelha o CHECK constraint de notifications.type na API.
export const NOTIFICATION_TYPES = ['ad', 'update', 'task', 'push'] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

// 'task' não é criado manualmente pelo painel — fica pro sistema automático
// (manejo pendente por propriedade). Só entra no dropdown de criação isto:
export const CREATABLE_TYPES = ['ad', 'update', 'push'] as const;

export interface NotificationImage {
  url: string;
  link?: string;
}

export interface Notification {
  id: number;
  type: NotificationType;
  title: string;
  body: string;
  images: NotificationImage[];
  items: string[];
  link: string | null;
  force: boolean;
  sendPush: boolean;
  minVersion: string | null;
  targetPropertyId: number | null;
  startsAt: string;
  endsAt: string | null;
  priority: number;
  readCount: number;
  lastSent: number | null;
  lastFailed: number | null;
  lastDispatchedAt: string | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationInput {
  type: NotificationType;
  title: string;
  body: string;
  images?: NotificationImage[];
  items?: string[];
  link?: string;
  force?: boolean;
  sendPush?: boolean;
  minVersion?: string;
  targetPropertyId?: number;
  startsAt?: string;
  endsAt?: string;
  priority?: number;
}

export interface DispatchResult {
  sent: number;
  failed: number;
}

export interface DispatchSkipped {
  error: 'DISPATCH_SKIPPED';
  reason: 'not_configured' | 'not_found' | 'no_devices' | 'push_disabled' | 'not_dispatchable';
}

export interface NotificationEngagement {
  available: boolean;
  received: number;
  opened: number;
}

export interface DeviceInsights {
  totalDevices: number;
  devicesWithPushToken: number;
  activeLast30d: number;
  inactiveLast30d: number;
}

export const notificationsApi = {
  list: async (): Promise<Notification[]> => {
    const res = await axiosClient.get<{ notifications: Notification[] }>('/manager/notifications');
    return res.data.notifications ?? [];
  },

  create: async (data: NotificationInput): Promise<Notification> => {
    const res = await axiosClient.post<{ notification: Notification }>(
      '/manager/notifications',
      data
    );
    return res.data.notification;
  },

  dispatch: async (id: number): Promise<DispatchResult> => {
    const res = await axiosClient.post<DispatchResult>(`/manager/notifications/${id}/dispatch`);
    return res.data;
  },

  remove: async (id: number): Promise<void> => {
    await axiosClient.delete(`/manager/notifications/${id}`);
  },

  engagement: async (id: number): Promise<NotificationEngagement> => {
    const res = await axiosClient.get<NotificationEngagement>(
      `/manager/notifications/${id}/engagement`
    );
    return res.data;
  },

  deviceInsights: async (): Promise<DeviceInsights> => {
    const res = await axiosClient.get<DeviceInsights>('/manager/notifications/insights/devices');
    return res.data;
  },
};
